// ********* CardCategorias - categorias.jsx ********
// autor: W de Paula / MVinfo
// data: 06/6/24 | 17h50
// **************************************************


import { Link } from 'react-router-dom';
import './categorias.css';

function CardCategorias(props){

    const imgSrc = `data:image/png;base64,${props.categoria_icone}`; // Certifique-se de que o tipo de imagem está correto (não é aspas simples e sim crases ``)
    const handleClick = () => {
        localStorage.setItem("id_categoria", props.categoria_id);
    };

    return (
        <div className='categoria-box text-center'>
            <Link to={'/app/cliente/home/explorar'} onClick={handleClick} style={{ textDecoration: 'none' }}> {/* eliminar o underline de todo o Link 7/6/24w */}
            {/* <Link to={'/app/cliente/home/explorar'} onClick={handleClick}> */}
                <img src={imgSrc} className="categoria-icone" alt="foto categoria" />
                <p className='categoria-descricao'>{props.categoria_descricao}</p>
            </Link>        
        </div>
    )
}

export default CardCategorias;